import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { Priority, QuestVisibility } from "@pages/jobs-management/constants";
import { PlatformEnum, PlatformType, PostJobFormType } from "@pages/post-job/types";

import { JobManagementActions } from "./constants";

type ActionType = (typeof JobManagementActions)[keyof typeof JobManagementActions];

export type JobFields = {
  title: string;
  description: string;
  detailOfWork: string;
  budget: number;
  priority: string;
  visibility: string;
  dueDate: string;
  aiPrompt?: string;
  skills: any[];
  platform: PlatformType[];
};
type JobManagementSliceState = {
  actions: (ActionType | "")[];
  stream: boolean;
  fields: JobFields | null;
};

const initialState: JobManagementSliceState = {
  actions: [],
  stream: false,
  fields: {
    title: "",
    description: "",
    detailOfWork: "",
    budget: 0,
    priority: Priority.MEDIUM,
    aiPrompt: "",
    visibility: QuestVisibility.PROJECT,
    dueDate: new Date().toString(),
    skills: [],
    platform: [PlatformEnum.LANCE_BOARD],
  },
};

const jobManagementSlice = createSlice({
  name: "jobManagement",
  initialState,
  reducers: {
    setStreamJob: (state, action: PayloadAction<boolean>) => {
      state.stream = action.payload;
    },
    setJobFields: (state, action: PayloadAction<JobFields>) => {
      state.fields = action.payload;
    },
    clearJobFields: (state) => {
      state.fields = null;
    },
  },
});

const { reducer, actions: jobManagementActions } = jobManagementSlice;

export { jobManagementActions };

export const { clearJobFields, setJobFields, setStreamJob } = jobManagementSlice.actions;

export default reducer;
